<template>
  <div class="app-wrapper" :style="{ '--current-color': theme }">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <!-- <div class="affix-container" v-if="showHLogin">
      <hz-navbar @setLayout="setLayout" :configurationData="configurationData" />
    </div> -->
    <!-- <div
      :class="{ hasTagsView: needTagsView, sidebarHide: sidebar.hide }"
      class="main-container"
    > -->
    <div :class="{
      'main-container': route.name == 'hzdialing', // 当不是 hzdialing 时才加 main-container
      hasTagsView: needTagsView,
      sidebarHide: sidebar.hide,
    }">
      <div class="main-wrapper main-wrappers">
        <app-main />
      </div>
    </div>
    <settings ref="settingRef" />
    <!-- <div class="home_footer" v-if="showHLogin">
      <div class="home_footer_main">
        <div class="home_footer_main_left">
          <div class="home_footer_main_left_login">
            <img v-if="
              configurationData &&
              configurationData.logoUrl != '' &&
              configurationData.logoUrl != null &&
              configurationData.logoUrl != undefined
            " :src="url + configurationData.logoUrl" alt="" />
            <img v-else src="/ffflogo.png" alt="" />
          </div>

          <div class="home_footer_main_left_contact">
            <div class="home_footer_main_left_contact_title">联系我们</div>
            <div class="home_footer_main_left_contact_content">
              {{ configurationData && configurationData.lxdh }}
            </div>
            <div class="home_footer_main_left_contact_content">
              {{ configurationData && configurationData.email }}
            </div>
            <div class="home_footer_main_left_contact_content">
              {{ configurationData && configurationData.address }}
            </div>
          </div>
          <div class="home_footer_main_left_more">
            <div class="home_footer_main_left_more_title">更多</div>
            <div class="home_footer_main_left_more_content">常见问题</div>
            <div class="home_footer_main_left_more_content">客服中心</div>
          </div>
        </div>
        <div class="home_footer_main_right">
          <div class="home_footer_main_right_content">
            <div class="home_footer_main_right_content_title">关注公众号</div>
            <div class="home_footer_main_right_content_qrcode"></div>
          </div>
        </div>
      </div>
      <div class="home_footer_bottom">山东黑蜂智运物流科技有限公司</div>
    </div> -->
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { useWindowSize } from "@vueuse/core";
import Sidebar from "./components/Sidebar/index.vue";
import { AppMain, hzNavbar, Settings, TagsView } from "./components";
import defaultSettings from "@/settings";

import useUserStore from "@/store/modules/user";
import useAppStore from "@/store/modules/app";
import useSettingsStore from "@/store/modules/settings";
const url = ref(import.meta.env.VITE_APP_BASE_API + "/file/download/?fileId=");

const route = useRoute();

const userStore = useUserStore();
const settingsStore = useSettingsStore();
const theme = computed(() => settingsStore.theme);
const sideTheme = computed(() => settingsStore.sideTheme);
const sidebar = computed(() => useAppStore().sidebar);
const device = computed(() => useAppStore().device);
const needTagsView = computed(() => settingsStore.tagsView);
const fixedHeader = computed(() => settingsStore.fixedHeader);
const showHLogin = ref(true);
const configurationData = ref({});

const classObj = computed(() => ({
  hideSidebar: !sidebar.value.opened,
  openSidebar: sidebar.value.opened,
  withoutAnimation: sidebar.value.withoutAnimation,
  mobile: device.value === "mobile",
}));

const { width, height } = useWindowSize();
const WIDTH = 992; // refer to Bootstrap's responsive design

watch(
  () => device.value,
  () => {
    if (device.value === "mobile" && sidebar.value.opened) {
      useAppStore().closeSideBar({ withoutAnimation: false });
    }
  }
);

watchEffect(() => {
  if (width.value - 1 < WIDTH) {
    useAppStore().toggleDevice("mobile");
    useAppStore().closeSideBar({ withoutAnimation: true });
  } else {
    useAppStore().toggleDevice("desktop");
  }
});

function handleClickOutside() {
  useAppStore().closeSideBar({ withoutAnimation: false });
}

const settingRef = ref(null);
function setLayout() {
  settingRef.value.openSetting();
}
const showFunction = () => {
  // showHLogin.value = false;
  if (
    route.name == "hzdialing" ||
    route.name == "dsplace" ||
    route.name == "sales" ||
    route.name == "xsxunjia" ||
    route.name == "hzregister" ||
    route.name == "gysxpquotation" ||
    route.name == "hzxpconfirm" ||
    route.name == "xptd" ||
    route.name == "gysregister" ||
    route.name == "loginbmd" ||
    route.name == "houtai" ||
    route.name == "gzh" ||
    route.name == "Wxlogin" ||
    route.name == "productDetails" ||
    route.name == "Order" ||
    route.name == "moveprogress" ||
    route.name == "orderdetails" ||
    route.name == "PersonalCenter" ||
    route.name == "moveinquiry" ||
    route.name == "xunpan" ||
    route.name == "certification" ||
    route.name == "IncomingNotification" ||
    route.name == "booking" ||
    route.name == "Notice" ||
    route.name == "address" ||
    route.name == "newaddress" ||
    route.name == "Modules" ||
    route.name == "placeanorder" ||
    route.name == "MobileLogin" ||
    route.name == "MobilePlaceanorder" ||
    route.name == "CapacityInquirySharedetails"
  ) {
    showHLogin.value = false;
  } else {
    showHLogin.value = true;
  }
};
function Configuration() {
  // userStore.getConfiguration(); // 获取配置信息
  setTimeout(() => {
    configurationData.value = userStore.configurationData;
  }, 500);
}
Configuration();
showFunction();
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixin.scss";
@import "@/assets/styles/variables.module.scss";

// 当屏幕宽度大于700px
@media (min-width: 700px) {
  .inquire_main {
    display: block;
  }
}

// 当屏幕宽度小于700px
@media (max-width: 700px) {

  /* 或者 < 700px */
  .home_footer {
    display: none;
    /* 或者 inline, inline-block, flex 等，取决于你希望它如何显示 */
  }
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  background-color: rgba(244, 245, 248, 1);

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$base-sidebar-width});
  transition: width 0.28s;
}

.main-content {
  // margin-left: $base-sidebar-width;
}

#app .main-container {
  min-height: auto;
  // padding-top: 4.75rem;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.sidebarHide .fixed-header {
  width: 100%;
}

.mobile .fixed-header {
  width: 100%;
}

.backgroundImage {
  width: 100%;
  height: 18.75rem;
  margin-top: 4.75rem;
}

.backgroundImage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.affix-container {
  width: 100%;
  height: auto;
}

.main-wrapper {
  width: 100%;
  height: 100%;
  // background-color: rgba(244, 245, 248, 1);
  overflow: hidden;
}

.main-wrappers {
  margin: 0;
  padding: 0;
}

.hasTagsView .app-main {
  width: 100%;
  height: auto;
  min-height: auto;
}

.home_footer {
  width: 100%;
  height: 21.5625rem;
  // background: rgba(255, 255, 255, 1);
  // background: rgb(5,42,108);
  background: rgb(5, 42, 108) url("/Rectangle.png");
  background-repeat: no-repeat;
  /* 通常配合 no-repeat 使用 */
  background-position: center;
  /* 通常配合 center 使用，以便图片居中 */
  background-size: contain;
  margin-top: 1px;

  .home_footer_main {
    width: 100%;
    max-width: 75rem;
    height: 90%;
    margin: 0 auto;
    display: flex;

    .home_footer_main_left {
      width: 80%;
      height: 100%;
      display: flex;

      .home_footer_main_left_login {
        display: inline-block;
        width: auto;
        padding-top: 3.375rem;

        img {
          width: 6.2381rem;
          height: 2.0625rem;
        }
      }

      .home_footer_main_left_more {
        display: inline-block;
        width: auto;
        padding-top: 3.375rem;
        margin-left: 22.8869rem;

        .home_footer_main_left_more_title {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 24px;
          line-height: 24px;
          letter-spacing: 0%;
          vertical-align: middle;
          // color: #000;
          color: #fff;
          margin-bottom: 1.25rem;
        }

        .home_footer_main_left_more_content {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0%;
          vertical-align: middle;
          // color: rgba(51, 51, 51, 0.7);
          color: rgb(210, 217, 228);
          margin-top: 0.75rem;
        }
      }

      .home_footer_main_left_contact {
        display: inline-block;
        width: auto;
        padding-top: 3.375rem;
        margin-left: 6.3125rem;

        .home_footer_main_left_contact_title {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 24px;
          line-height: 24px;
          letter-spacing: 0%;
          vertical-align: middle;
          color: #fff;
          margin-bottom: 1.25rem;
        }

        .home_footer_main_left_contact_content {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0%;
          vertical-align: middle;
          color: rgb(210, 217, 228);
          margin-top: 0.75rem;
        }
      }
    }

    .home_footer_main_right {
      width: 20%;
      height: 100%;
      display: flex;

      .home_footer_main_right_content {
        width: 100%;
        height: 100%;
        padding-top: 3.375rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        .home_footer_main_right_content_title {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
          letter-spacing: 0%;
          text-align: center;
          vertical-align: middle;
          // color: rgba(51, 51, 51, 1);
          color: #fff;
        }

        .home_footer_main_right_content_qrcode {
          width: 9.625rem;
          height: 9.625rem;
          border: 1px solid rgba(231, 231,231, 1);
          border-radius: 10px;
          margin-top: 1.125rem;
        }
      }
    }
  }

  .home_footer_bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(51, 51, 51, 0.4);
  }
}
</style>